/* eslint-disable */
(function($) {
    $.fn.extend({
        Accordion: function(options) {

            // expand first panel on page load
            if (document.body.contains(document.getElementById('accordion1'))) {
                window.onload = toggleAccordion(document.getElementById('accordion1'));
            }

            var acc = document.querySelectorAll('[id^="accordion"]');

            for (i = 0; i < acc.length; i++) {
                // add toggle click event to header element
                $(acc[i]).on("click", "h3", toggleAccordion);
                $(acc[i]).on("keydown", "h3", function(e) {
                    const keyD = e.key !== undefined ? e.key : e.keyCode;
                    if ( (keyD === 'Enter' || keyD === 13) || (['Spacebar', ' '].indexOf(keyD) >= 0 || keyD === 32)) {
                        e.preventDefault();
                        toggleAccordion(e);
                    }
                });
            }

            function toggleAccordion(evt) {
                const el = evt instanceof Element ? evt : evt.delegateTarget;
                el.classList.toggle("active");
                var panel = el.childNodes[0].nextElementSibling.nextElementSibling.nextElementSibling;
                if (panel.style.maxHeight) {
                  panel.style.maxHeight = null;
                  $(panel).prev().attr("aria-expanded","false");
                  $(panel).attr("aria-hidden","true");
                } else {
                  panel.style.maxHeight = panel.scrollHeight + "px";
                  $(panel).prev().attr("aria-expanded","true");
                  $(panel).attr("aria-hidden","false");
                }
            }
        }
    });
})(jQuery);
/* eslint-enable */
